// src/api/catalogClient.js
const base = '/api/catalog';

export async function fetchCatalog(kind) {
  const res = await fetch(`${base}/${kind}`, { credentials: 'same-origin' });
  if (!res.ok) throw new Error(`Catalog ${kind} failed: ${res.status}`);
  const { data } = await res.json();
  return data || [];
}
